import { ItemOrientation } from '@syncfusion/ej2-ribbon';
import { RibbonGroupBase } from '../ribbon-interfaces';
import { showSpinner, hideSpinner } from '@syncfusion/ej2-popups';
/**
 * Table of Contents group implementation for Reference tab
 * @private
 */
export class TableOfContentsGroup extends RibbonGroupBase {
    /**
     * Constructor for TableOfContentsGroup
     * @param {DocumentEditorContainer} container - DocumentEditorContainer instance
     */
    constructor(container) {
        super(container);
        // Constants for IDs
        this.TOC_BUTTON_ID = '_toc';
        this.UPDATE_TOC_BUTTON_ID = '_update_toc';
    }
    /**
     * Get the Ribbon items for Table of Contents group
     * @returns {RibbonGroupModel} - Ribbon group model for Table of Contents group
     * @private
     */
    getGroupModel() {
        return {
            header: this.localObj.getConstant('Table of Contents'),
            enableGroupOverflow: true,
            overflowHeader: this.localObj.getConstant('Table of Contents'),
            orientation: ItemOrientation.Row,
            collections: [
                {
                    items: [
                        {
                            type: 'Button',
                            keyTip: 'T',
                            buttonSettings: {
                                content: this.localObj.getConstant('Table of Contents'),
                                iconCss: 'e-icons e-de-ctnr-tableofcontent',
                                clicked: this.insertTableOfContents.bind(this)
                            },
                            id: this.ribbonId + this.TOC_BUTTON_ID,
                            ribbonTooltipSettings: {
                                title: this.localObj.getConstant('Table of Contents'),
                                content: 'Insert a table of contents'
                            }
                        },
                        {
                            type: 'Button',
                            keyTip: 'U',
                            disabled: true,
                            buttonSettings: {
                                content: this.localObj.getConstant('Update Table'),
                                iconCss: 'e-icons e-de-ctnr-table-update',
                                clicked: this.updateTocHandler.bind(this)
                            },
                            id: this.ribbonId + this.UPDATE_TOC_BUTTON_ID,
                            ribbonTooltipSettings: {
                                title: this.localObj.getConstant('Update Table'),
                                content: 'Update the table of contents'
                            }
                        }
                    ]
                }
            ]
        };
    }
    /**
     * Insert Table of Contents
     * @returns {void}
     */
    insertTableOfContents() {
        showSpinner(this.documentEditor.element);
        setTimeout(() => {
            this.documentEditor.editorModule.insertTableOfContents();
            hideSpinner(this.documentEditor.element);
        });
    }
    /**
     * Update Table of Contents handler
     * @returns {void}
     */
    updateTocHandler() {
        const isReadOnly = this.documentEditor.isReadOnlyMode;
        if (this.documentEditor.selection.isReferenceField() && (!isReadOnly ||
            (isReadOnly && this.documentEditor.documentHelper.protectionType === 'FormFieldsOnly'))) {
            this.documentEditor.selection.updateRefField();
        }
        else if (!isReadOnly) {
            this.documentEditor.editorModule.updateToc();
        }
    }
    /**
     * Update UI based on selection state
     * @returns {void}
     * @private
     */
    updateSelection() {
        const isInTocField = this.documentEditor.selection.contextType === 'TableOfContents';
        if (isInTocField) {
            this.container.ribbon.ribbon.enableItem(this.ribbonId + this.UPDATE_TOC_BUTTON_ID);
        }
        else {
            this.container.ribbon.ribbon.disableItem(this.ribbonId + this.UPDATE_TOC_BUTTON_ID);
        }
    }
}
